export default class ChartisanHooks {
  tooltip(show) {
    this.show = show;
    return this;
  }

  legend(legend) {
    this.legend = legend;
    return this;
  }

  datasets(datasets) {
    this.datasets = datasets;
    return this;
  }
}
